import { Col, Row } from "react-bootstrap";
import ModalContainer, {
  ModelContainerProps,
} from "../../../../shared/oversight-core/ui-elements/modal-container/modal-container";

interface IProps extends ModelContainerProps {
  show: boolean;
  siteName: string;
  isActive?: boolean;
}

const DisableSiteModal = (props: IProps) => {
  const { show, siteName, isActive, ...rest } = props;

  return (
    <ModalContainer
      {...rest}
      show={show}
      size="modal-md"
      confirmButtonText={isActive ? `Disable` : `Enable`}
      cancelButtonText="Cancel"
      confirmButtonVariant={isActive ? `red` : `blue`}
      title={isActive ? "Disable Site" : "Enable Site"}
    >
      <>
        <Row>
          <Col className="text-light font-weight-500 font-size-14">
            {isActive ? `Disable` : `Enable`} {siteName}?
          </Col>
        </Row>
        <Row>
          <Col className="text-light font-weight-400 font-size-14">
            {isActive
              ? `Are you sure you want to disable and hide ${siteName} and hide site
            throughout the monitoring platform?`
              : `Are you sure you want to re enable ${siteName}?`}
          </Col>
        </Row>
      </>
    </ModalContainer>
  );
};

export default DisableSiteModal;
